import type { TFunction } from 'i18next';

export function buildAvailabilityEnquiryHref(
  unitLabel: string,
  city: string | undefined,
  t: TFunction<'inventory'>,
): string {
  const subject = t('availability.enquireSubject', {
    unitLabel,
    city: city ? ` (${city})` : '',
  });
  return `mailto:?subject=${encodeURIComponent(subject)}`;
}
